<lib-dialog>
  <div class="importar-dependencia-dialog">
    <div class="dialog-header">
      <h3 class="dialog-title">Importar</h3>
      <button
        type="button"
        class="close-btn"
        (click)="cancelar()"
        [disabled]="importando()"
        aria-label="Cerrar"
      >
        ✕
      </button>
    </div>

    <div class="steps-indicator">
      <div
        class="step"
        [class.active]="!importacionCompletada()"
        [class.completed]="importacionCompletada()"
      >
        <div class="step-number">1</div>
        <div class="step-label">Subir Archivo</div>
      </div>
      <div class="step-line" [class.active]="importacionCompletada()"></div>
      <div class="step" [class.active]="importacionCompletada()">
        <div class="step-number">2</div>
        <div class="step-label">Resultado</div>
      </div>
    </div>

    <div class="dialog-content">
      @if (!importacionCompletada()) {
        <div class="step-content">
          <div class="upload-section">
            <h4 class="section-title">Seleccionar archivo para importar</h4>

            <lib-file-upload
              [accept]="'.csv,.xlsx'"
              [maxSize]="5242880"
              [multiple]="false"
              [label]="'Seleccionar archivo'"
              [hint]="'Formatos: CSV, Excel (XLSX) Tamaño máximo: 5MB'"
              (filesSelected)="onFilesSelected($event)"
            >
            </lib-file-upload>

            @if (archivoSeleccionado()) {
              <div class="file-info-card">
                <div class="file-info-header">
                  <div class="file-icon-wrapper">
                    <lib-icon name="FileText"></lib-icon>
                  </div>
                  <div class="file-info-details">
                    <h4>{{ archivoSeleccionado()?.name }}</h4>
                    <p>{{ archivoSeleccionado()?.size || 0 | number }} bytes</p>
                  </div>
                </div>
                <div class="file-info-actions">
                  <lib-button variant="secondary" prefixIcon="Trash2" (clicked)="limpiarArchivo()">
                    Eliminar
                  </lib-button>
                  <lib-button
                    variant="primary"
                    prefixIcon="Upload"
                    [loading]="importando()"
                    [disabled]="!puedeImportar()"
                    (clicked)="importarArchivo()"
                  >
                    {{ importando() ? 'Importando...' : 'Importar Archivo' }}
                  </lib-button>
                </div>
              </div>
            }
            @if (importando()) {
              <div class="loading-indicator">
                <div class="loading-spinner"></div>
                <span>Procesando archivo, por favor espere...</span>
              </div>
            }
          </div>
        </div>
      }

      <br />
      @if (mostrarAlerta()) {
        <lib-alert
          [type]="alertaTipo()"
          [title]="alertaTitulo()"
          [message]="alertaMensaje()"
          [closeButton]="true"
          (closed)="cerrarAlerta()"
        ></lib-alert>
      }

      @if (importacionCompletada() && summary()) {
        <div class="step-content">
          <div class="result-section">
            <div class="summary-cards">
              <div class="summary-card total">
                <span class="card-value">{{ summary()!.total }}</span>
                <span class="card-label">Total Registros</span>
              </div>
              <div class="summary-card created">
                <span class="card-value">{{ summary()!.created }}</span>
                <span class="card-label">Creados</span>
              </div>
              <div class="summary-card updated">
                <span class="card-value">{{ summary()!.updated }}</span>
                <span class="card-label">Actualizados</span>
              </div>
              <div class="summary-card skipped">
                <span class="card-value">{{ summary()!.skipped }}</span>
                <span class="card-label">Omitidos</span>
              </div>
              <div class="summary-card invalid" [class.has-errors]="summary()!.invalid > 0">
                <span class="card-value">{{ summary()!.invalid }}</span>
                <span class="card-label">Inválidos</span>
              </div>
              @if (
                summary()!.failedValidations !== undefined && summary()!.failedValidations !== null
              ) {
                <div
                  class="summary-card failed-validations"
                  [class.has-errors]="summary()!.failedValidations! > 0"
                >
                  <span class="card-value">{{ summary()!.failedValidations }}</span>
                  <span class="card-label">Validaciones Fallidas</span>
                </div>
              }
            </div>

            @if (hayErrores()) {
              <div class="errors-section">
                <div class="errors-header">
                  <h5>Errores encontrados</h5>
                </div>
                <div class="errors-table-wrapper">
                  <table class="errors-table">
                    <thead>
                      <tr>
                        <th class="col-line">Línea</th>
                        <th class="col-field">Campo</th>
                        <th class="col-message">Mensaje</th>
                        <th class="col-value">Valor Recibido</th>
                      </tr>
                    </thead>
                    <tbody>
                      @for (error of errors(); track error.line + error.field + $index) {
                        <tr [class]="getErrorClass(error.rule)">
                          <td>{{ error.line || '-' }}</td>
                          <td>{{ error.field || '-' }}</td>
                          <td>
                            <span class="error-message" [class]="getErrorClass(error.rule)">
                              {{ getErrorMessage(error) }}
                            </span>
                          </td>
                          <td>{{ error.receivedValue ?? 'campo vacio' }}</td>
                        </tr>
                      }
                    </tbody>
                  </table>
                </div>
              </div>
            }

            <div class="result-actions">
              @if (hayErrores()) {
                <lib-button
                  variant="secondary"
                  prefixIcon="FileDown"
                  (clicked)="descargarReporteErrores()"
                >
                  Descargar Reporte
                </lib-button>
              }
              <lib-button variant="primary" (clicked)="cerrarDialogo()">
                {{ hayErrores() ? 'Aceptar' : 'Finalizar' }}
              </lib-button>
            </div>
          </div>
        </div>
      }
    </div>

    @if (!importacionCompletada()) {
      <div class="dialog-footer">
        <div class="actions">
          <lib-button variant="secondary" [disabled]="importando()" (clicked)="cancelar()">
            Cancelar
          </lib-button>
        </div>
      </div>
    }
  </div>
</lib-dialog>
